<template>
  <YdDialog :visible="visibleLook" append-to-body @close="closeLook" width="450px">
    <div
      class="limit-coupon-page flex flex-col flex-align-center padding-bottom-20"
      :style="{
        'background-image': 'url(' + activeInfo.headImgUrl + ')',
        'background-color': activeInfo.backcolor,
        'background-size': '100% 216px !important',
        'background-position': 'top !important',
        'background-repeat': 'no-repeat'
      }"
      style="position: relative"
      v-if="activeInfo"
    >
      <!-- 优惠券 -->
      <div class="coupon-box">
        <div class="time-box font-14" v-if="activeInfo.startTime">
          {{ activeInfo.startTime }}至{{ activeInfo.endTime }}
        </div>
        <div class="color-bg-fff border-radius-20" style="padding: 0px 15px 15px 15px">
          <div
            class="coupon-item position-relative"
            v-for="(item, index) in activeInfo.couponInfoList"
            :key="item.couponId"
          >
            <img
              src="https://qiniu-business.ayundi.cn/activity/1728462012420_limit-coupon-bg.png"
              class="img-bg"
            />
            <div class="flex flex-align-center info-box" slot="inner">
              <div class="limit-num font-12"> 每日{{ item.totalNum }}份 </div>
              <div class="left flex">
                <div class="price-box flex">
                  <div class="price" v-if="item.type">{{
                    item.type === 3 ? item.discountsCondition * 10 : item.discountsMoney
                  }}</div>
                  <div class="unit">{{ item.type === 3 ? '折' : '元' }}</div>
                </div>
                <div class="content">
                  <div class="type">{{ item.name }}</div>
                  <div class="tip">{{ item.extraMsg }}</div>
                  <div class="stuats-box color-333 font-10">
                    <div v-if="status === 1">
                      <div class="font-color">{{ item.str }}</div
                      >开始
                    </div>
                    <div class="flex flex-align-center" v-else-if="item.state === 2">
                      <div class="schedule">
                        <div
                          class="schedule-num flex flex-justify-end"
                          :style="{ width: getProgress(index) + '%' }"
                        >
                          <img
                            class="icon"
                            v-if="getProgress(index) > 0"
                            :style="{ right: (getProgress(index) > 4 ? -4 : -7) + 'px' }"
                            src="https://qiniu-business.ayundi.cn/activity/1728463943563_limit-coupon-progress.png"
                            mode="aspectFit"
                          />
                        </div>
                      </div>
                      <div class="margin-left-2">已抢{{ item.receiveNum || 0 }}</div>
                    </div>
                    <div v-else-if="item.state === 3">
                      距过期仅剩<div class="font-color">{{ item.str }}</div
                      >天
                    </div>
                    <div v-else-if="item.state === 4">已过期</div>
                    <div v-else-if="item.state === 5"
                      ><span v-if="item.str.length > 3">下一场</span
                      ><span :class="{ 'font-color': item.str.length > 3 }">{{
                        item.str
                      }}</span></div
                    >
                  </div>
                </div>
              </div>
              <div class="right flex flex-align-center flex-col flex-justify-center">
                <div class="coupon-btn padding-x-15 btn-1" v-if="item.state === 1">未开始</div>
                <div class="coupon-btn padding-x-6 btn-2" v-else-if="item.state === 2"
                  >立即领取</div
                >
                <div class="coupon-btn padding-x-15 btn-2" v-else-if="item.state === 3">去使用</div>
                <div class="coupon-btn padding-x-15 btn-4" v-else>{{
                  item.state == 4 ? '已过期' : '已抢光'
                }}</div>
                <div class="font-12 margin-top-3 color-999 num"
                  >限领{{ activeInfo.everyPersonTime }}张</div
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 规则 -->
      <div class="rule-box margin-top-10">
        <div class="color-bg-fff full-height padding-x-15 border-radius-20 rule-content">
          <div v-html="activeInfo.rule"></div>
        </div>
      </div>
    </div>
  </YdDialog>
</template>

<script>
  import { limitedInfo } from '@/api/marketing/activities-api'
  export default {
    name: 'LimitCoupon',
    data() {
      return {
        activeInfo: {}
      }
    },
    props: {
      visibleLook: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      notice() {
        return ''
      }
    },
    mounted() {},
    methods: {
      closeLook() {
        this.activeInfo = {}
        this.$emit('closeLook')
      },
      async init(id) {
        const { code, data } = await limitedInfo(id)
        if (code) return
        data.startTime = data.startTime ? data.startTime.split(' ')[0] : ''
        data.endTime = data.endTime ? data.endTime.split(' ')[0] : ''
        data.couponInfoList.forEach((item) => {
          // 处理优惠券内容
          item.extraMsg =
            item.type === 1
              ? item.isAll
                ? '全部线路可用'
                : '指定线路可用'
              : item.type === 2
              ? `满${(item.discountsCondition * 1) / 100}可用`
              : `最高抵扣${item.discountsMoney}`
          item.receiveNum = Number(item.receiveNum)
          item.totalNum =
            item.dayNum <= item.surplusNum ? item.dayNum : item.surplusNum + item.receiveNum
        })
        this.activeInfo = data
        // console.log('this.activeInfo', this.activeInfo.headImgUrl)
      },
      getProgress(index) {
        const obj = this.activeInfo.couponInfoList[index]
        if (!(obj.receiveNum + obj.totalNum)) {
          return 0
        }
        const receiveNum = obj.receiveNum // 领取数量
        const totalNum = obj.totalNum // 总份数
        return ((receiveNum / totalNum) * 100).toFixed(2)
      }
    }
  }
</script>
<style scoped lang="scss">
  .limit-coupon-page {
    width: 375px;
    padding-top: 190px;
    .coupon-box {
      padding-top: 34px;
      width: 343px;
      border-radius: 20px;
      box-sizing: border-box;
      background: url('https://qiniu-business.ayundi.cn/activity/1728462269056_limit-coupon-header.png')
        no-repeat;
      background-size: 100% 123px;
      background-position: top;
      .time-box {
        width: 257px;
        height: 27px;
        background: url('https://qiniu-business.ayundi.cn/activity/1728460343214_limit-coupon-time.png')
          no-repeat;
        background-size: 100% 100%;
        padding-left: 75px;
        font-family: Douyin Sans, Douyin Sans-600;
        font-weight: 600;
        text-align: center;
        line-height: 27px;
        margin: 0 0 27px 8px;
        box-sizing: border-box;
      }
      .coupon-item {
        margin-bottom: 12px;
        .img-bg {
          width: 313px;
          height: 88px;
          position: absolute;
          top: 0;
          left: 0;
        }
        &:last-child {
          margin-bottom: 0;
        }
        .info-box {
          position: relative;
          .limit-num {
            position: absolute;
            top: 0;
            left: 0;
            height: 22px;
            line-height: 22px;
            padding: 0 10px 0 5px;
            background: url('https://qiniu-business.ayundi.cn/activity/1728462119917_limit-coupon-num.png')
              no-repeat;
            background-size: 100% 100%;
            color: #fff;
            font-family: Source Han Sans CN, Source Han Sans CN-400;
            font-weight: 400;
          }
          .left {
            flex: 1;
            .price-box {
              width: 85px;
              padding: 26px 0 14px 15px;
              box-sizing: border-box;
              align-items: baseline;
              .price {
                font-size: 32px;
                font-family: Source Han Sans CN, Source Han Sans CN-700;
                font-weight: 700;
                text-align: LEFT;
                color: #f62112;
              }
              .unit {
                font-size: 10px;
                font-family: Source Han Sans CN, Source Han Sans CN-400;
                font-weight: 400;
                text-align: LEFT;
                color: #f62112;
              }
            }
            .content {
              .type {
                margin-top: 19px;
                font-size: 16px;
                font-family: Source Han Sans CN, Source Han Sans CN-700;
                font-weight: 700;
                color: #333333;
              }
              .tip {
                font-size: 12px;
                font-family: Source Han Sans CN, Source Han Sans CN-400;
                font-weight: 400;
                color: #999999;
                margin-top: 3px;
              }
              .stuats-box {
                font-family: Source Han Sans CN, Source Han Sans CN-500;
                font-weight: 500;
                margin-top: 3px;
                .font-color {
                  color: #ff520c;
                }
                .schedule {
                  width: 86px;
                  height: 10px;
                  background: #fedddb;
                  border-radius: 5px;
                  position: relative;
                  .schedule-num {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 50%;
                    height: 100%;
                    border-radius: 5px;
                    background: linear-gradient(90deg, #fe7348, #eb4f46 52%, #f62112 100%),
                      linear-gradient(271deg, #ff5009 0%, #ff9667 53%);
                    .icon {
                      width: 12px;
                      height: 12px;
                      position: absolute !important;
                      top: -1px;
                    }
                  }
                }
              }
            }
          }
          .right {
            width: 92px;
            height: 100%;
            .coupon-btn {
              display: flex;
              align-items: center;
              color: #fff;
              box-sizing: border-box;
              height: 32px;
              border-radius: 23px;
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-700;
              font-weight: 700;
            }
            .btn-1 {
              background: linear-gradient(90deg, #fe7348, #eb4f46 52%, #f62112 100%);
              opacity: 0.5;
            }
            .btn-2 {
              background: linear-gradient(90deg, #fe7348, #eb4f46 52%, #f62112 100%);
            }
            .btn-4 {
              background: linear-gradient(90deg, #c3c3c3, #999999 100%);
            }
            .num {
              font-family: Source Han Sans CN, Source Han Sans CN-400;
              font-weight: 400;
              height: 18px;
              line-height: 18px;
            }
          }
        }
      }
    }
    .rule-box {
      background: url('https://qiniu-business.ayundi.cn/activity/1728462035147_limit-coupon-rule.png')
        no-repeat;
      background-size: 100% 78px;
      background-position: top;
      width: 343px;
      box-sizing: border-box;
      padding-top: 52px;
      .rule-content {
        min-height: 93px;
        padding-bottom: 10px;
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
</style>
